import(/* webpackMode: "eager" */ "/vercel/path0/app/(mitra)/products/news/page.js")